import React from 'react';
import logo from '../../assets/logo.png';

export const PageNotFound = () => {
	React.useEffect(() => {
		document.body.style.background = '#1f222e';
	}, []);
	return (
		<>
			<a href="/dashboard" class="logo-link-notfound" title="back home">
				<img src={logo} width="60" class="logo" alt="Company's logo" />
			</a>

			<div class="content-notfound">
				<div class="content-notfound-box">
					<div class="big-content-notfound">
						<div class="list-square">
							<span class="square"></span>
							<span class="square"></span>
							<span class="square"></span>
						</div>

						<div class="list-line">
							<span class="line"></span>
							<span class="line"></span>
							<span class="line"></span>
							<span class="line"></span>
							<span class="line"></span>
							<span class="line"></span>
						</div>

						<i class="feather icon-search" aria-hidden="true"></i>

						<div class="clear"></div>
					</div>

					<h1>Oops! Error 404 not found.</h1>

					<p>
						The page you were looking for doesn't exist.
						<br />
						We think the page may have moved.
					</p>
				</div>
			</div>

			<footer class="light-notfound">
				<ul>
					<li>
						<a href="#">Support</a>
					</li>
					<li>
						<a href="#">
							<i class="feather icon-facebook"></i>
						</a>
					</li>
					<li>
						<a href="#">
							<i class="feather icon-twitter"></i>
						</a>
					</li>
				</ul>
			</footer>
		</>
	);
};
